<script>

import { useToast } from "vue-toastification";
import LoadingScreen from '@/components/General/LoadingScreen'
import LoadingButton from '@/components/General/LoadingButton'
import Alert from '@/components/General/Alert'

//general functions
import MixinGeneralFunct from '@/mixins/GeneralFunctions';
import { defineComponent } from 'vue'

//data
import { getStateOptions } from '@/services/serviceCommon';
import { getAccessRightsOptions } from '@/services/serviceAccessRight';
import { getLevel,unlockLevel, saveLevel, createLevel } from '@/services/serviceLevel';

export default defineComponent ({
	setup() {
		const toast = useToast();
		return { toast }
	},
	name: 'LevelEdit',
	mixins: [ MixinGeneralFunct ],
	components: {
		LoadingScreen
		,LoadingButton
		,Alert
	},
	props: {'levelId': String, 'auth':Object, 'secData':Object, 'modalObject': Object, 'modalId': String},
	emits: ["levelId","changeRecord"],
	data() {
		return {
			params:[],
			metaData: [],
			
			isLoading:true,
			isSending:false,
			
			optionsAccessLevels:[],
			optionsStates:[],
			
			//form
			data:[]
		}
	},
	
	mounted:function(){

	},
	
	methods: {
		// load data form
		loadDefaultValues:function(){
			
			this.isLoading=true
			
			getLevel({levelId:this.levelId}).then(response => {
				if(!response.statusText){
					this.isLoading=false
					this.metaData = response.metaData;
					this.data = response.data;
				}else{
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});

			getAccessRightsOptions().then(response => {
				if(!response.statusText){
					this.optionsAccessLevels = response.optionsAccessLevels;
				}else{
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});

			getStateOptions().then(response => {
				if(!response.statusText){
					this.optionsStates = response.optionsStates;
				}else{
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});
		
		},
		
		checkSave:function(){
				
			if(!this.data.title){this.data.titleError = true;}else{this.data.titleError = false;}
			if(!this.data.access){this.data.accessError = true;}else{this.data.accessError = false;}
			if(!this.data.state){this.data.stateError = true;}else{this.data.stateError = false;}
			
			if(!this.data.titleError && !this.data.accessError && !this.data.stateError){
				return true;
			}else{
				this.toast.warning(this.$t('msgCore.fillInAllData'));
				return false;
			}
		},	
		
		onSave:function(){
				
			if(this.checkSave()){
				if(this.levelId!='null'){
					this.isSending=true
					saveLevel({data:this.data}).then(response => {
						if(!response.statusText){
							this.isSending=false
							if(response.resCode==1){
								this.toast.success(this.$t('msgCore.dataWasSaved'));
								this.$emit('changeRecord', '')
								this.data = [];
								this.modalObject.hide();
							}else if(response.resCode==0){
								this.toast.warning(this.$t('msgCore.dataCantBeSaved'));
							}else if(response.resCode==2){
								this.toast.warning(this.$t('msgCore.dataCantBeSaved'));
							}else if(response.resCode==3){
								this.toast.error(this.$t('msgCore.accessDenied'));
							}
						}else{
							this.isSending=false
							this.toast.error(`${response.statusText} ${response.status}`);
						}
					});
				}else{	
					createLevel({data:this.data}).then(response => {
						if(!response.statusText){
							this.isSending=false
							if(response.resCode==1){
								this.toast.success(this.$t('msgCore.dataWasSaved'));
								this.$emit('changeRecord', '')
								this.data = [];
								this.modalObject.hide();
							}else if(response.resCode==0){
								this.toast.warning(this.$t('msgCore.dataCantBeSaved'));
							}else if(response.resCode==2){
								this.toast.warning(this.$t('msgCore.dataCantBeSaved'));
							}else if(response.resCode==3){
								this.toast.error(this.$t('msgCore.accessDenied'));
							}
						}else{
							this.isSending=false
							this.toast.error(`${response.statusText} ${response.status}`);
						}
					});
				}
			}
			
		},

		onClose:function(){
			if(this.levelId!='null'){
				unlockLevel({levelId:this.levelId}).then(response => {
					if(!response.statusText){
						this.isLoading=false
						if(response.resCode==1){
							this.$emit('changeRecord', '')
							this.modalObject.hide();
						}
					}else{
						this.isLoading=false
						this.toast.error(`${response.statusText} ${response.status}`);
					}
				});
			}else{
				this.$emit('changeRecord', '')
				this.modalObject.hide();
			}
		},
		
		
		
	},
	
	watch: {
		levelId() {
			this.loadDefaultValues();
		}
	},

	computed:{
		
	},
	
})

</script>

<template>
	<div>
		<div class="modal fade" :id="modalId" tabindex="-1" >
			<div class="modal-dialog modal-lg">
				<LoadingScreen :isLoading="isLoading"></LoadingScreen>
				<div class="modal-content">
					<div class="modal-header">
						<h6 class="modal-title">{{ $t('msgCore.AccessLevel') }} <span v-if="data.isNewRecord">{{ $tc('msgCore.new',1) }}</span><span v-else><b>{{ data.title }}</b> id: {{data.id}}</span></h6>
						
						
					</div>
			
							<div v-if="metaData.modulAccess && (auth.levelsEdit || auth.levelsNew)" class="modal-body">
								
								<div class="row">
									<div class="col-12">
										<div v-if="data.isCheckedOut && secData.userId != data.isCheckedOutId" class="angle">
											<span class="angle-inner" :class="{'angle-warning':data.isCheckedOut}"><i class="fa" :class="{'angle-warning':data.isCheckedOut, 'fa-exclamation-triangle':data.isCheckedOut}" aria-hidden="true"></i> {{$t('msgCore.Edited')}} </span >
											
											<span v-if="data.isCheckedOut" class="personCircle v-center" v-bind:style="{background:data.isCheckedOutColor}" v-bind:title="data.isCheckedOutName+', '+data.isCheckedOutDate">{{ data.isCheckedOutLetterName+''+data.isCheckedOutLetterSurname }}</span>
										</div>
									</div>
								</div>	
								
								<div class="row">
									
									<div class="col-md-8 col-12">

											<div class="row">
												
												<div class="col-md-4 col-12">
													<label :class="{'text-danger':data.titleError}"><b>{{ $t('msgCore.Title') }}</b> </label>
													<input type="text" class="form-control form-control-sm" :class="{'is-invalid':data.titleError}" v-on:change="checkSave()" v-model="data.title" >
													<div v-show="data.titleError" class="error-input"><span class="badge badge-pill badge-danger">{{$t('msgCore.fillIn')}}</span></div>
												</div>
												
											</div>	
									</div>
									
									<div class="col-md-4 col-12 form-control-system-data">
									
										<div class="col-12">
											<label :class="{'text-danger':data.accessError}"><b>{{ $t('msgCore.AccessLevel') }}</b></label>
																								
											<select v-model='data.access' class="form-control form-control-sm " :class="{'is-invalid':data.accessError}" v-on:change="checkSave()">
												<option  value="">{{ $t('msgCore.selectLevel') }}</option>
												<option v-for="(option) in optionsAccessLevels" :key="option" :value="option.value">{{ option.title }}</option>
											</select>
											<div v-show="data.accessError" class="error-input"><span class="badge badge-pill badge-danger">{{$t('msgCore.selectLevel')}}</span></div>
										</div>
										
										<div class="col-12">
											<label :class="{'text-danger':data.stateError}"><b>{{ $t('msgCore.State') }}</b></label>
											
												<div  v-for="(option) in optionsStates" :key="option" class="form-check">
													<label class="form-check-label">
														<input class="form-check-input" type="radio" name="optionsStates"  v-model='data.state' v-on:change="checkSave()" :value="option.value">
														{{ $t('msgCore.'+option.title) }}
														<span class="circle">
															<span class="check"></span>
														</span>
													</label>
												</div>
											<div v-show="data.stateError" class="error-input"><span class="badge badge-pill badge-danger">{{$t('msgCore.selectState')}}</span></div>
										</div>
												
									</div>
									
								</div>		
							
							</div>
							
							<div v-else class="modal-body">
								<div class="row">
									<div class="col-12 mt-3">
										<Alert type="warning" :label="$t('msgCore.accessDenied')" />
									</div>
								</div>
							</div>
							
							
							
							<div class="modal-footer">
							
								<div class="btn-group">
									<button type="button" v-on:click="onClose()" class="btn btn-default btn-sm">{{ $t('msgCore.btnClose') }}</button>
									
									<LoadingButton :isDisabled="((!auth.levelsEdit) || (!auth.levelsNew) || isSending || !metaData.modulAccess)" :isSending="isSending" @onClick="onSave" :label="'msgCore.btnSave'" color="warning"></LoadingButton>
								</div>	
								
							</div>
						
				
					
					
				
				</div>

			</div>
			
		</div>
	</div>
		
</template>


